import { DeliveryProvider, OFFER_KIND, PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  customer_info: {
    dummy_order: 'Ordine di prova',
    ordered_at: 'Ordinato alle:',
  },
  delivery_info: {
    info: 'Info consegna:',
  },
  order_note: {
    label: 'Nota ordine:',
  },
  schedule_info: {
    pickup: 'Ritiro',
    delivery: 'Consegna',
    room_service_location: {
      room_service: 'Camera',
      table_service: 'Tavolo',
    },
    wish_time: 'Orario desiderato:',
    confirmed_time: 'Orario confermato:',
    driver_arrival_time: 'Orario ritiro corriere:',
    external_delivery: "L'ordine è consegnato da un corriere esterno di {{carrier}}",
  },
  products: {
    item: 'Articolo:',
  },
  discount_breakdown: {
    label: 'Sconto',
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Sconto percentuale sul totale applicato',
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Sconto percentuale sui prodotti applicato',
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Sconto fisso sui prodotti applicato',
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Sconto fisso sul totale applicato',
    [OFFER_KIND.BOGO]: 'Bogo applicato',
    [OFFER_KIND.BOGO_HALF_PRICE]: 'Bogo metà prezzo applicato',
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Articolo gratuito per prodotti applicato',
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Articolo gratuito per totale applicato',
    GiftCard: 'Gift card applicata',
    Reward: 'Punti fedeltà applicati',
    CashbackAccount: 'Punti fedeltà applicati',
    PromoCodeComponent: 'Promo applicata',
    Offer: 'Offerta applicata',
  },
  payment_breakdown: {
    price: 'Prezzo:',
    subtotal: 'Subtotale',
    delivery_fee: 'Costo di consegna',
    tips: 'Mancia',
    processing_fee: 'Commissione servizio online',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'Commissione PayPal',
    },
    tax: 'Tasse',
    total: 'Totale',
    paid_amount: 'Importo pagato',
    order_not_paid: 'Ordine non ancora pagato',
    order_paid_online: 'Già pagato online',
    cash: 'Pagamento in loco',
    this_is_not_an_invoice: 'Questo non è una fattura',
  },
  delivery_qr_code: {
    scan: 'Scansiona e consegna con Google Maps',
  },
  delivery_providers: {
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
};
